"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = _interopRequireDefault(require("../styles"));
var _ListItemButton = _interopRequireDefault(require("@mui/material/ListItemButton"));
var _tokens = require("../styles/tokens");
var _classnames = _interopRequireDefault(require("classnames"));
var _globalSpacing = require("../globalSpacing");
var _List = require("./List");
var _excluded = ["root"],
  _excluded2 = ["classes"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var styles = function styles(theme) {
  return {
    root: {
      paddingTop: _tokens.spacing30,
      paddingBottom: _tokens.spacing30
    },
    listButton: {
      cursor: 'pointer',
      '&:hover, &:focus': {
        backgroundColor: theme.palette.grey['250'],
        color: theme.palette.grey['600']
      },
      '&:active': {
        backgroundColor: theme.palette.ctaColor.active,
        color: theme.palette.grey['100'],
        '& svg': {
          fill: theme.palette.grey['100']
        }
      },
      '&:focus': {
        outline: 'none',
        boxShadow: _tokens.boxShadowFocusInset
      }
    },
    gutters: {
      // Reset MUI default padding
      paddingLeft: _tokens.spacing40,
      paddingRight: _tokens.spacing40
    },
    none: {
      padding: 0
    },
    dense: {},
    disabled: {},
    divider: {}
  };
};

/**
 * A simple wrapper component to apply button styles to ListItems.
 */
var ListItemButton = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var _cn;
  var _props$classes = props.classes,
    root = _props$classes.root,
    restOfClasses = (0, _objectWithoutPropertiesLoose2.default)(_props$classes, _excluded),
    rest = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded2);
  var _useContext = (0, _react.useContext)(_List.ListContext),
    spacing = _useContext.spacingOptions.spacing;
  var classOverrides = (0, _extends2.default)({
    root: (0, _classnames.default)(root, restOfClasses.listButton, (_cn = {}, _cn[restOfClasses.none] = spacing === _globalSpacing.spacingVariant.NONE, _cn)),
    gutters: restOfClasses.gutters
  }, restOfClasses);
  return /*#__PURE__*/_react.default.createElement(_ListItemButton.default, (0, _extends2.default)({}, rest, {
    classes: classOverrides,
    ref: ref
  }));
});
ListItemButton.muiName = 'ListItemButton';
ListItemButton.displayName = 'ListItemButton';
ListItemButton.propTypes = {
  /**
   * The content of the component if a `ListItemSecondaryAction` is used it must
   * be the last child.
   */
  children: _propTypes.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes.default.object,
  /**
   * @ignore
   */
  className: _propTypes.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: _propTypes.default.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent List component.
   */
  dense: _propTypes.default.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: _propTypes.default.bool,
  /**
   * If `true`, the left and right padding is removed.
   */
  disableGutters: _propTypes.default.bool,
  /**
   * If `true`, a 1px light border is added to the bottom of the list item.
   */
  divider: _propTypes.default.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object, _propTypes.default.bool])), _propTypes.default.func, _propTypes.default.object])
};
ListItemButton.defaultProps = {
  dense: false,
  disabled: false,
  disableGutters: false,
  divider: false
};
var _default = (0, _styles.default)(styles)(ListItemButton);
exports.default = _default;